import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { Button, Icon, Label } from "semantic-ui-react";
import FileUploader from "./FileUploader";
import AppSettings from "../config";
import "./CommentFileUploader.scss";

interface ICommentFileUploader {
  name: string;
  control: any;
  defaultValue: any;
  readonly?: boolean;
  required?: boolean;
  folder: string;
  onRemoved?: any;
  onUploaded?: any;
}

export const CommentFileUploader = ({
  name,
  control,
  onUploaded,
  onRemoved,
  readonly,
  required,
  defaultValue,
  folder,
}: ICommentFileUploader) => {
  const [files, setFiles] = useState<any[]>(defaultValue || []);

  useEffect(() => {
    setFiles(defaultValue || []);
  }, [defaultValue]);

  return (
    <Controller
      control={control}
      name={name}
      rules={{ required: required && "This field is required" }}
      required={required}
      render={({ onChange, value }) => {
        return (
          <div style={{ display: "flex" }} className='comment-file-uploader'>
            {!readonly && (
              <FileUploader
                baseUrl={AppSettings.CONTENT_URL}
                bucket={AppSettings.DIRECT_UPLOAD_BUCKET}
                folder={folder}
                file={null}
                setFile={(file: any) => {
                  onChange([...files, file]);
                  setFiles([...files, file]);
                  if (onUploaded) {
                    onUploaded(file);
                  }
                }}
                uploadId='file'
                placeholder={
                  <Button icon secondary type='button' aria-label={"Add attachment"}>
                    <Icon name='attach' color='grey' />
                  </Button>
                }
              />
            )}
            {files.map((file: any, index: number) => {
              if (readonly) {
                return (
                  <p key={file.name}>
                    <a href={file.signedUrl} target='_blank' rel='noopener noreferrer'>
                      {file.name}
                    </a>
                  </p>
                );
              }
              return (
                <Label key={file.name} basic>
                  <div style={{ fontSize: 14, display: "flex", alignItems: "center", height: "100%" }}>
                    {file.signedUrl ? (
                      <a href={file.signedUrl} target='_blank' rel='noopener noreferrer'>
                        {file.name}
                      </a>
                    ) : (
                      file.name
                    )}
                    <Icon
                      name='close'
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      onClick={() => {
                        const removed = files[index];
                        const newValue = _.filter(value, (v: any, i: number) => i !== index);
                        setFiles(newValue);
                        onChange(newValue);
                        if (onRemoved) {
                          onRemoved(removed);
                        }
                      }}
                    />
                  </div>
                </Label>
              );
            })}
          </div>
        );
      }}
    />
  );
};
